interface DashboardHeaderProps {
  readonly asOf?: string;
}

export function DashboardHeader({ asOf }: DashboardHeaderProps) {
  return (
    <header className="border-b border-divider pb-4">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
        <h1 className="bg-gradient-to-r from-accent to-product bg-clip-text text-3xl font-bold text-transparent">
          Oilseed &amp; VegOil Relative Value Dashboard
        </h1>

        {asOf ? (
          <div className="shrink-0 rounded border border-divider bg-raised px-3 py-1.5 text-xs font-medium text-secondary">
            Latest Data:{" "}
            <time className="font-semibold tabular-nums text-primary" dateTime={asOf}>
              {asOf}
            </time>
          </div>
        ) : null}
      </div>
    </header>
  );
}
